import { Injectable } from "@angular/core";
import Swal from 'sweetalert2'

@Injectable()
export class AlertService {
  toastNotify({type, text, timer}) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: timer,
    });

    return Toast.fire({
      type: type,
      text: text,
    })
  }
}


// WEBPACK FOOTER //
// /opt/app/src/app/services/alert.service.ts